import React from "react";
import CommonDocumentModuleInterface from "@/pages/T4/CommonDocumentModuleInterface";
import { useParams } from "react-router-dom";

interface T3ApprovedOnboardingDocumentListProps {}

const T3ApprovedOnboardingDocumentList: React.FC<
  T3ApprovedOnboardingDocumentListProps
> = () => {
  const { id } = useParams();
  return (
    <>
      <CommonDocumentModuleInterface
        isView={true}
        userId={id}
        isApprovedView={true}
      />
    </>
  );
};

export default T3ApprovedOnboardingDocumentList;
